import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import DesignButton from 'components/lv1/designButton'
import SelectLanguage from 'components/lv1/selectLanguage'

import StylesModule from 'components/lv3/topImage.module.scss'
import TopMainImg from 'images/top/main.jpg'
import TopMainTextJa from 'images/top/main_text_ja.svg'
import TopMainTextEn from 'images/top/main_text_en.svg'

import { MessageProps } from 'message/index.props'

export interface TopImageProps {
  message: MessageProps
  lang: string
}

const useStyles = makeStyles(() => ({
  bgImage: {
    backgroundImage: `url(${TopMainImg})`,
  },
}))

const TopImage: FC<TopImageProps> = ({ message, lang }) => {
  let TopMainText = ''
  let svgClassName = ''
  switch (lang) {
    case 'ja':
      TopMainText = TopMainTextJa
      svgClassName = 'topImage__svgNameJa'
      break
    case 'en':
      TopMainText = TopMainTextEn
      svgClassName = 'topImage__svgNameEn'
      break
  }
  const classes = useStyles()
  return (
    <section>
      <div className={classNames(classes.bgImage, StylesModule.topImage)}>
        <div className={StylesModule.topImage__wrap}>
          <div className={StylesModule.topImage__languageWrap}>
            <SelectLanguage language={message.global.language} />
          </div>
          <div className={StylesModule.topImage__reservationWrap}>
            <DesignButton
              label={message.global.reservation}
              to={message.global.reservation_button.url}
              design="top-fill"
            />
          </div>
        </div>
        <div className={StylesModule.topImage__mainWrap}>
          <img
            src={TopMainText}
            alt={message.top.catchcopy}
            className={classNames(
              StylesModule[svgClassName],
              StylesModule.topImage__catchcopy,
            )}
            area-label={message.top.catchcopy}
          />
        </div>
      </div>
    </section>
  )
}

export default TopImage
